import { render } from "./VendorMaterialsStockSelector.vue?vue&type=template&id=b6b3541e&scoped=true&lang=pug"
import script from "./VendorMaterialsStockSelector.vue?vue&type=script&lang=ts"
export * from "./VendorMaterialsStockSelector.vue?vue&type=script&lang=ts"

import "./VendorMaterialsStockSelector.vue?vue&type=style&index=0&id=b6b3541e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b6b3541e"

export default script